import React, { useState, useEffect, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import { Box, Button, Typography, Divider, Checkbox, Fade, Backdrop, CircularProgress, Grid } from '@mui/material';
import logo from '../assets/images/Layer_1.png';
import signupimg from '../assets/images/signupimg00.png';
import { Link as MUILink } from '@mui/material';
import CustomInputBox from '../components/customInputBox/CustomInputBox';
import { Lock, Email, AccountCircle } from '@mui/icons-material';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { useNavigate, Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingButton from '@mui/lab/LoadingButton';
import { createCompany } from '../graphql/mutations';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CustomPhoneInputBox from '../components/customInputBox/CustomPhoneInputBox';
import localStorage from 'redux-persist/es/storage';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { useDispatch } from 'react-redux';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import packageJson from '../../package.json';
import { showErrorSnackbar, showWarningSnackbar } from '../components/snackBar/snakbar';
import axios from 'axios';
import { useDebounce } from '../hooks/useDebounce';
import { matchIsValidTel } from 'mui-tel-input';
import API_ENDPOINTS from '../apiEndpoints';
import { CLIENT_ID } from '../config.js';
import { capitalizeWords } from '../utils/common';

const Signup = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState({
    password: false,
    cpassword: false,
  });

  const [state, setState] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    open: false,
    confirmPassword: '',
    errorStatus: {
      name: false,
      phone: false,
      email: false,
      password: false,
      confirmPassword: false,
      'family-name': false,
    },
    errorFields: {
      name: '',
      phone: '',
      email: '',
      password: '',
      confirmPassword: '',
      open: '',
      'family-name': '',
    },
  });

  const [BackDrop, setBackDrop] = useState(false);

  const [termsStatus, setTermsStatus] = useState(false);
  const [isAcceptTerms, setIsAcceptTerms] = useState(true);

  let horizontal = matches ? 'center' : 'left';
  let vertical = matches ? 'top' : 'bottom';

  // EMAIL VALIDATION HANDLER (field-level)
  const handleEditError = (name, value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

    if (!value || value.trim() === '') {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: 'Email Address is Required',
        },
      }));
      showErrorSnackbar('Email Address is Required', horizontal, vertical);
      return;
    }

    if (!emailRegex.test(value)) {
      setState((prev) => ({
        ...prev,
        [name]: value,
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
        errorFields: {
          ...prev.errorFields,
          [name]: 'Invalid Email Address',
        },
      }));
      return;
    }

    // Valid email
    setState((prev) => ({
      ...prev,
      [name]: value,
      errorStatus: {
        ...prev.errorStatus,
        [name]: false,
      },
      errorFields: {
        ...prev.errorFields,
        [name]: '',
      },
    }));
  };

  const debouncedSearch = useCallback(
    useDebounce(
      (name, value) => {
        handleEditError(name, value);
      },
      500,
      false
    ),
    []
  );

  useEffect(() => {
    createScript();
  }, []);

  // Load the Google client
  const createScript = () => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = initGsi;
    document.body.appendChild(script);
  };

  // Initialize Google client and render Google button
  const initGsi = () => {
    if (window.google && window.google?.accounts) {
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: async (response) => {
          try {
            setBackDrop(true);
            const option = {
              method: 'POST',
              url: API_ENDPOINTS.REACT_APP_SIGNUP_CHECK2,
              data: JSON.stringify({ credential: response.credential }),
            };
            const responseA = await axios(option);

            if (responseA.status == 200 || responseA.status == 201) {
              await Auth.federatedSignIn({
                provider: CognitoHostedUIIdentityProvider.Google,
              });
            } else {
              showWarningSnackbar(responseA.data.error);
            }
          } catch (e) {
            console.log('error', e);
          } finally {
            setBackDrop(false);
          }
        },
      });
      const referenceWidth = document.getElementById('signUpBox')?.offsetWidth || 250;
      window.google.accounts.id.renderButton(document.getElementById('googleSignInButton'), {
        theme: 'outline',
        size: 'large',
        width: referenceWidth,
        text: 'signup_with',
      });
    }
  };

  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault();
        handleForSubmission();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [state, termsStatus]);

  const handleForSubmission = (event) => {
    setSubmit(true);
    const { name, phone, email, password, confirmPassword } = state;
    const family_name = state['family-name']; 
    const formData = {
      name,
      phone,
      email,
      password,
      confirmPassword,
      termsStatus,
      family_name,
      'family-name': state['family-name'],
    };
    if (formValidation(formData)) {
      if (formData.termsStatus) {
        setLoading(true);
        setBackDrop(true);
        setIsAcceptTerms(true);
        signingUp(formData);
      } else {
        setIsAcceptTerms(false);
        showErrorSnackbar('Please accept the Terms of Services and Privacy Policy', horizontal, vertical);
      }
    }
  };

  async function signingUp(values) {
    try {
      let response = await axios.post(API_ENDPOINTS.REACT_APP_SIGNUP_CHECK, {
        email: values.email,
      });

      if (response.request.status === 200) {
        // NO DUPLICATE ACCOUNT EXISTS THEN CREATE NEW ACCOUNT
        let username = values.email;
        let password = values.password;
        let email = values.email;
        let name = values.name;
        let phone_number = values.phone ? values.phone.replace(/\s+/g, '') : '';
        let family_name = values.family_name; 
        localStorage.setItem('emailID', email);
        localStorage.setItem('mobileNo', phone_number);
        localStorage.setItem('UserName', name);
        Auth.signUp({
          username,
          password,
          attributes: {
            name,
            email,
            phone_number, // optional - E.164 number convention
            family_name: family_name, 
        }})
          .then((user) => {
            setState((prev) => ({
              ...prev,
              open: false,
              errorFields: {
                ...prev.errorFields,
                open: '',
              },
            }));
            localStorage.setItem('emailID', email);
            localStorage.setItem('mobileNo', phone_number);
            localStorage.setItem('UserName', name);
            // clear signup temp data
            localStorage.removeItem('mobileNumber');
            localStorage.removeItem('signUpEmail');
            localStorage.removeItem('signUpPassword');
            localStorage.removeItem('checkBoxCheck');
            localStorage.removeItem('signUpName');
            localStorage.removeItem('signUpFamilyName');
            navigate('/confirmsignup', {
              state: {
                email: email,
                password: password,
                company: state.name,
              },
            });
          })
          .catch((error) => {
            if (error.code === 'UsernameExistsException') {
              setState((prev) => ({
                ...prev,
                open: true,
                errorFields: {
                  ...prev.errorFields,
                  open: error.message,
                },
              }));
            }
            console.log('error on signining in :: ', error);
          });
      } else {
        if (response.data.error == 'You Have Already Registered. You Can Login.') {
          showErrorSnackbar('You have already signed up! Please log in using your existing credentials');
        } else {
          showErrorSnackbar(response.data.error);
        }
      }

      //CHECK GOOGLE ACCOUNT ALREADY EXISTS
    } catch (error) {
      console.log('error on signining in 2 try :: ', error);
    } finally {
      setBackDrop(false);
      setLoading(false);
    }
  }

  const formValidation = (data) => {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^\+(?:\d\s?){6,14}\d$/;
    const passwprdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/;
    const companynameRegex = /^[a-zA-Z][a-zA-Z0-9_& -]*$/;
    let isvalid = true;

    Object.keys(data).map((itemKey) => {
      if (itemKey === 'phone') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Mobile number is Required',
            },
          }));
        } else if (!matchIsValidTel(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Invalid Mobile Number',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'name') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'First Name is Required',
            },
          }));
        }
      }

      if (itemKey === 'family-name') {
        if (!data[itemKey] || data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Last Name is Required',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'email') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Email Address is Required',
            },
          }));
        } else if (!regex.test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Invalid Email address',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }

      if (itemKey === 'password') {
        if (data[itemKey].trim().length <= 0) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: 'Password is Required',
            },
          }));
        } else if (!passwprdRegex.test(data[itemKey])) {
          isvalid = false;
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: true,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        } else {
          setState((prev) => ({
            ...prev,
            errorStatus: {
              ...prev.errorStatus,
              [itemKey]: false,
            },
            errorFields: {
              ...prev.errorFields,
              [itemKey]: '',
            },
          }));
        }
      }
    });

    return isvalid;
  };

  function handleLogin() {
    localStorage.removeItem('mobileNumber');
    localStorage.removeItem('signUpEmail');
    localStorage.removeItem('signUpPassword');
    localStorage.removeItem('checkBoxCheck');
    localStorage.removeItem('signUpName');
    localStorage.removeItem('signUpFamilyName');
    navigate('/login');
  }

  useEffect(() => {
    async function getMoboleNumber() {
      const savedPhone = await localStorage.getItem('mobileNumber');
      const savedEmail = await localStorage.getItem('signUpEmail');
      const savedPassword = await localStorage.getItem('signUpPassword');
      const checkBoxCheck = await localStorage.getItem('checkBoxCheck');
      const savedFirstName = await localStorage.getItem('signUpName');
      const savedLastName = await localStorage.getItem('signUpFamilyName');

      if (checkBoxCheck === 'true') {
        setTermsStatus(true);
      }

      if (savedFirstName) {
        setState((prev) => ({
          ...prev,
          name: savedFirstName,
        }));
      }

      if (savedLastName) {
        setState((prev) => ({
          ...prev,
          ['family-name']: savedLastName,
        }));
      }

      if (savedPhone) {
        setState((prev) => ({
          ...prev,
          phone: savedPhone,
        }));
      }
      if (savedEmail) {
        setState((prev) => ({
          ...prev,
          email: savedEmail,
        }));
      }
      if (savedPassword) {
        setState((prev) => ({
          ...prev,
          password: savedPassword,
        }));
      }
    }
    getMoboleNumber();
  }, []);

  // 🔴 NOTE: keeping this as-is (clears on full page unload, not on SPA nav)
  useEffect(() => {
    const handleReload = () => {
      localStorage.removeItem('mobileNumber');
      localStorage.removeItem('signUpEmail');
      localStorage.removeItem('signUpPassword');
      localStorage.removeItem('checkBoxCheck');
      localStorage.removeItem('signUpName');
      localStorage.removeItem('signUpFamilyName');
    };
    window.addEventListener('beforeunload', handleReload);
    return () => {
      window.removeEventListener('beforeunload', handleReload);
    };
  }, []);

  return (
    <>
      <Backdrop open={BackDrop} sx={{ zIndex: 999 }}>
        <CircularProgress />
      </Backdrop>
      <Fade in={true}>
        <Box
          className="hgfghf"
          sx={{
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#E2E0ED',
            backgroundImage: { md: `url(${signupimg})`, sm: '' },
            backgroundSize: { lg: 'auto 65%', md: 'auto 50%' },
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundPosition: 'top right',
            width: '100%',
            minHeight: '100vh',
            height: '100%',
            padding: {
              xs: '8px 8px',
              sm: '30px 40px',
              md: '0px 0px',
            },
            boxSizing: 'border-box',
          }}
        >
          <Box
            id="123"
            sx={{
              scale: '0.94',
              height: {
                sm: '60%',
                md: '90%',
                lg: '97%',
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              width: {
                xs: '100%',
                sm: '80%',
                md: '50%',
                lg: '60%',
              },
              paddingLeft: {
                xs: '0px',
                md: '30px',
              },
              paddingRight: {
                xs: '0px',
                md: '30px',
              },
              paddingTop: {
                xs: '0px',
                sm: '30px',
                md: '30px',
              },
              paddingBottom: {
                xs: '0px',
                sm: '10px',
                md: '0',
                lg: '0',
              },
              marginTop: {
                sm: '0px',
                md: '5px',
                lg: '0',
              },
            }}
          >
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                position: 'relative',
                ml: '10px',
                width: {
                  xs: '80%',
                  md: '300px',
                  lg: '350px',
                },
                mb: '10px',
              }}
            >
              <img
                src={logo}
                style={{
                  height: '90px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              />
            </Box>
            <Box
              sx={{
                display: { xs: 'block', sm: 'none' },
                minHeight: '90px',
                backgroundImage: `url(${logo})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                mb: { xs: '5px', sm: '' },
                width: '90%',
              }}
            />
            <Box
              sx={{
                width: {
                  xs: '100%',
                  sm: '80%',
                  xs: '100%',
                  sm: '80%',
                  md: '300px',
                  lg: '350px',
                },
                minHeight: '20%',
                maxHeight: {
                  xs: '90%',
                  md: '100%',
                },
                padding: { sm: '10px', xs: '5px' },
                backgroundColor: 'transparent',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'max-height 0.5s ease',
              }}
            >
              <Box
                sx={{
                  color: '#75428C',
                  display: 'flex',
                  gap: '10px',
                  alignItems: 'center',
                  mt: {
                    xs: '1%',
                  },
                  mb: '10%',
                  maxHeight: '130px',
                  width: '100%',
                  height: '50px',
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: '16px',
                      sm: '16px',
                      md: '17px',
                      lg: '16px',
                    },
                    color: '#2a2afaea',
                    fontWeight: 'bolder',
                    marginLeft: '28px',
                  }}
                >
                  Already an existing user ?
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                  }}
                >
                  <Button
                    onClick={handleLogin}
                    sx={{
                      flex: 1,
                      pl: '15px',
                      pr: '15px',
                      ml: '5px',
                      ':hover': { background: '#1212eeea' },
                      width: '105%',
                      border: '0',
                      whiteSpace: 'nowrap',
                      fontSize: {
                        xs: '12px',
                        sm: '14px',
                        md: '16px',
                        lg: '15px',
                      },
                      fontWeight: {
                        xs: '400',
                        sm: '400',
                        md: '500',
                        lg: '500',
                      },
                      color: 'white',
                      height: {
                        xs: '25px',
                        sm: '30px',
                        md: '35px',
                        lg: '25px',
                      },
                      borderRadius: '11px',
                      background: '#3b3bf1ea',
                      textTransform: 'capitalize',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    disableRipple={true}
                  >
                    Login !
                  </Button>
                </Box>
              </Box>
              <Grid
                container
                direction="column"
                alignItems="center"
                sx={{
                  width: '100%',
                }}
              >
                <Grid
                  item
                  sx={{
                    mt: '-5px',
                    width: '100%',
                    display: 'block',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                  }}
                >
                  <Grid
                    item
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      height: '10%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <button type="button" id="googleSignInButton" />
                  </Grid>

                  <Grid
                    item
                    sx={{
                      mb: '10px',
                      mt: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0px 10px',
                    }}
                  >
                    <Grid item sx={{ width: '90%' }}>
                      <Divider textAlign="center">
                        <Typography sx={{ color: '#9F9F9F' }}>or</Typography>
                      </Divider>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  id="signUpBox"
                  sx={{
                    width: { xs: '100%', sm: '85%' },
                    maxHeight: '90%',
                    mt: '0px',
                  }}
                >
                  {/* FIRST NAME */}
                  <CustomInputBox
                    from={'signup'}
                    name="name"
                    placeholder="First Name"
                    type="text"
                    autoFocus={false}
                    autoComplete="first-name"
                    onBlur={(e) => {
                      const { name, value } = e.target;
                      if (!value) {
                        setState((prev) => ({
                          ...prev,
                          errorFields: { ...prev.errorFields, [name]: 'First Name is required' },
                          errorStatus: { ...prev.errorStatus, [name]: true },
                        }));
                      }
                    }}
                    onChange={(e) => {
                      let { name, value } = e.target;
                      value = capitalizeWords(value);
                      setState((prev) => ({
                        ...prev,
                        [name]: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: '',
                        },
                      }));
                      localStorage.setItem('signUpName', value);
                    }}
                    state={state}
                    icon={
                      <AccountCircle
                        sx={{
                          color: state.errorStatus.name ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                    value={state.name}
                  />

                  {/* LAST NAME */}
                  <CustomInputBox
                    from={'signup'}
                    name="family-name"
                    placeholder="Last Name"
                    type="text"
                    autoFocus={false}
                    autoComplete="last-name"
                    onBlur={(e) => {
                      const { name, value } = e.target;
                      if (!value || value.trim() === '') {
                        setState((prev) => ({
                          ...prev,
                          errorFields: { ...prev.errorFields, [name]: 'Last Name is required' },
                          errorStatus: { ...prev.errorStatus, [name]: true },
                        }));
                      }
                    }}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      const capitalizedValue = capitalizeWords(value);
                      setState((prev) => ({
                        ...prev,
                        [name]: capitalizedValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: '',
                        },
                      }));
                      localStorage.setItem('signUpFamilyName', capitalizedValue);
                    }}
                    state={state}
                    icon={
                      <AccountCircle
                        sx={{
                          color: state.errorStatus['family-name'] ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                    value={state['family-name'] || ''}
                  />

                  {/* PHONE */}
                  <CustomPhoneInputBox
                    from={'signup'}
                    autoFocus={true}
                    name="phone"
                    placeholder="Mobile Number"
                    defaultCountry="IN"
                    focusOnSelectCountry={true}
                    forceCallingCode={true}
                    disableFormatting={true}
                    onChange={(newPhone) => {
                      if (!matchIsValidTel(newPhone)) {
                        setState((prev) => ({
                          ...prev,
                          phone: newPhone,
                          errorStatus: {
                            ...prev.errorStatus,
                            phone: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            phone: 'Invalid Mobile Number',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          phone: newPhone,
                          errorStatus: {
                            ...prev.errorStatus,
                            phone: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            phone: '',
                          },
                        }));
                      }
                      localStorage.setItem('mobileNumber', newPhone);
                    }}
                    state={state}
                    value={state.phone}
                  />

                  {/* EMAIL */}
                  <CustomInputBox
                    from={'signup'}
                    name="email"
                    placeholder="Email Address (User Id)"
                    type="email"
                    autoFocus={false}
                    autoComplete=""
                    onBlur={(e) => {
                      const { name, value } = e.target;
                      handleEditError(name, value);
                    }}
                    onChange={(e) => {
                      const { name, value } = e.target;
                      if (submit) {
                        debouncedSearch(name, value);
                      }
                      setState((prev) => ({
                        ...prev,
                        [name]: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          [name]: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          [name]: '',
                        },
                      }));
                      localStorage.setItem('signUpEmail', value);
                    }}
                    state={state}
                    icon={
                      <Email
                        sx={{
                          color: state.errorStatus.email ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                    value={state.email}
                  />

                  {/* PASSWORD */}
                  <CustomInputBox
                    from={'signup'}
                    name="password"
                    placeholder="Password"
                    type={showPassword.password ? 'text' : 'password'}
                    autoFocus={false}
                    autoComplete="new-password"
                    value={state.password}
                    onChange={(e) => {
                      let { name, value } = e.target;
                      localStorage.setItem('signUpPassword', value);
                      value = value.replace(/\s+/g, '');
                      if (value === '') {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: 'Password is Required',
                          },
                        }));
                      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/.test(value)) {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          [name]: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            [name]: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            [name]: '',
                          },
                        }));
                      }
                    }}
                    state={state}
                    icon={
                      <Lock
                        sx={{
                          color: state.errorStatus.password ? 'danger.main' : '#8a8787',
                        }}
                        className="icon"
                      />
                    }
                    Icon={
                      <span
                        onClick={() => {
                          setShowPassword((prev) => ({
                            ...prev,
                            password: !showPassword.password,
                          }));
                        }}
                      >
                        {showPassword.password ? (
                          <VisibilityOffIcon
                            sx={{
                              color: state.errorStatus.password ? 'danger.main' : '#8a8787',
                            }}
                            className="iconpassword"
                          />
                        ) : (
                          <VisibilityIcon
                            sx={{
                              color: state.errorStatus.password ? 'danger.main' : '#8a8787',
                            }}
                            className="iconpassword"
                          />
                        )}
                      </span>
                    }
                  />

                  {/* PASSWORD RULES */}
                  <Grid container direction="column" sx={{ m: 0, pb: '2px' }}>
                    {state?.password.length > 0 && (
                      <>
                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            marginTop: '-10px',
                            marginLeft: '10px',
                            color: /[a-z]/.test(state.password) && /[A-Z]/.test(state.password) ? '#0DB66E' : '#F22E07',
                          }}
                        >
                          {/[a-z]/.test(state.password) && /[A-Z]/.test(state.password) ? (
                            <DoneIcon style={{ fontSize: '16px' }} />
                          ) : (
                            <CloseIcon style={{ fontSize: '16px' }} />
                          )}
                          <Typography
                            sx={{
                              fontSize: '11px',
                              color: /[a-z]/.test(state.password) && /[A-Z]/.test(state.password) ? '#0DB66E' : '#F22E07',
                            }}
                          >
                            Must Contain Atleast 1 Upper & lower case characters
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            marginLeft: '10px',
                            color: /\d/.test(state.password) ? '#0DB66E' : '#F22E07',
                          }}
                        >
                          {/\d/.test(state.password) ? (
                            <DoneIcon style={{ fontSize: '16px' }} />
                          ) : (
                            <CloseIcon style={{ fontSize: '16px' }} />
                          )}
                          <Typography
                            sx={{
                              fontSize: '11px',
                              color: /\d/.test(state.password) ? '#0DB66E' : '#F22E07',
                            }}
                          >
                            Must Contain Atleast 1 Number
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            marginLeft: '10px',
                            color: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.password) ? '#0DB66E' : '#F22E07',
                          }}
                        >
                          {/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.password) ? (
                            <DoneIcon style={{ fontSize: '16px' }} />
                          ) : (
                            <CloseIcon style={{ fontSize: '16px' }} />
                          )}
                          <Typography
                            sx={{
                              fontSize: '11px',
                              color: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(state.password) ? '#0DB66E' : '#F22E07',
                            }}
                          >
                            Must Contain Atleast 1 special character
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            marginLeft: '10px',
                            color: !/\s/g.test(state.password) && state.password.length > 1 ? '#0DB66E' : '#F22E07',
                          }}
                        ></Grid>

                        <Grid
                          item
                          sx={{
                            display: 'flex',
                            marginLeft: '10px',
                            color: state.password.length >= 8 ? '#0DB66E' : '#F22E07',
                          }}
                        >
                          {state.password.length >= 8 ? (
                            <DoneIcon style={{ fontSize: '16px' }} />
                          ) : (
                            <CloseIcon style={{ fontSize: '16px' }} />
                          )}
                          <Typography
                            sx={{
                              fontSize: '11px',
                              color: state.password.length >= 8 ? '#0DB66E' : '#F22E07',
                            }}
                          >
                            Must be Atleast 8 characters
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* TERMS CHECKBOX */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  textAlign: 'left',
                  '.css-1kpioai-MuiButtonBase-root-MuiCheckbox-root': {
                    color: 'input.border',
                  },
                  '.css-1kpioai-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
                    color: 'primary.main',
                  },
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: { sm: '90%', xs: '100%' },
                      display: 'flex',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <Checkbox
                      checked={termsStatus}
                      onChange={(e) => {
                        setTermsStatus(e.target.checked);
                        setIsAcceptTerms(e.target.checked);
                        localStorage.setItem('checkBoxCheck', e.target.checked);
                      }}
                      sx={{
                        mt: '-5px',
                        color: !termsStatus ? '#777777' : 'primary.black',
                      }}
                    />

                    <Typography
                      sx={{
                        marginTop: '10px',
                        fontSize: { xs: '12px', sm: '14px' },
                        color: !isAcceptTerms ? 'danger.main' : 'primary.black',
                      }}
                    >
                      I agree to{' '}
                      <MUILink underline="hover" sx={{ cursor: 'pointer' }}>
                        <Link style={{ textDecoration: 'none' }} to={'/termsofservices'}>
                          {' '}
                          Terms of Services
                        </Link>
                      </MUILink>{' '}
                      and{' '}
                      <MUILink underline="hover" sx={{ cursor: 'pointer' }}>
                        <Link style={{ textDecoration: 'none' }} to={'/privacypolicy'}>
                          {' '}
                          Privacy Policy
                        </Link>
                      </MUILink>
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* SUBMIT BUTTON */}
              <Box
                sx={{
                  textAlign: 'center',
                  paddingBottom: '10px',
                  paddingTop: '10px',
                }}
              >
                <LoadingButton
                  sx={{
                    width: { sm: '85%', xs: '100%' },
                    height: { lg: 50, md: 40 },
                    background: '#75428C',
                    color: 'white',
                    marginTop: '-5px',
                  }}
                  loading={loading}
                  disableRipple={true}
                  variant="contained"
                  onClick={(event) => handleForSubmission(event)}
                >
                  Create Account
                </LoadingButton>
              </Box>

              <Box
                sx={{
                  textAlign: 'center',
                  display: { xs: 'none', sm: 'block' },
                  mt: '20px',
                  mb: '5px',
                }}
              >
                <Typography color={'grey'}>Version {packageJson.version}</Typography>
              </Box>
            </Box>
          </Box>

          {/* RIGHT SIDE CONTENT */}
          {!matches ? (
            <Box
              sx={{
                width: '100%',
                maxHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '30px',
                paddingRight: '60px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <Box
                  sx={{
                    height: '72%',
                    width: '65%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        margin: '0 auto',
                        marginTop: {
                          md: '50px',
                          lg: '220px',
                          xl: '300px',
                        },
                        width: {
                          md: '105%',
                          lg: '550px',
                        },
                        pt: '12px',
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: 'left',
                          fontSize: '50px',
                          color: '#514b70c1',
                        }}
                      >
                        Hi,
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: '14px',
                          color: '#534E6E',
                          textAlign: 'justify',
                          marginTop: {
                            xl: '15px',
                          },
                        }}
                      >
                        Our innovative dashboard feature will make managing your finances significantly easier. Say goodbye to the hassle of
                        navigating through multiple screens – everything you need is right at your fingertips. From creating groups to
                        generating vouchers, our centralized dashboard allows you to perform all essential tasks from a single window.
                        <br />
                        <br />
                        This streamlined workflow not only saves you time but also enhances productivity, ensuring that you can focus on
                        what matters most - growing your business.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                width: {
                  xs: '90%',
                  sm: '80%',
                  md: '45%',
                  lg: '45%',
                },
                marginBottom: {
                  xs: '0px',
                  sm: '60px',
                  md: '0px',
                },
              }}
            >
              <Box sx={{ marginTop: { xs: '-12px', sm: '5px' } }}>
                <Typography
                  sx={{
                    color: '#8a82b0',
                    marginBottom: '15px',
                    mt: { xs: '0px', sm: '' },
                    fontWeight: 500,
                    textAlign: 'left',
                    fontSize: { sm: '60px', xs: '25px' },
                  }}
                >
                  Hi,
                </Typography>

                <Typography
                  sx={{
                    color: '#534E6E',
                    marginBottom: '30px',
                    textAlign: 'justify',
                  }}
                >
                  Our innovative dashboard feature will make managing your finances significantly easier. Say goodbye to the hassle of
                  navigating through multiple screens – everything you need is right at your fingertips. From creating groups to generating
                  vouchers, our centralized dashboard allows you to perform all essential tasks from a single window.
                  <br />
                  <br />
                  This streamlined workflow not only saves you time but also enhances productivity, ensuring that you can focus on what
                  matters most – growing your business.
                </Typography>
              </Box>
              <Box
                sx={{
                  textAlign: 'center',
                  display: { sm: 'none', xs: 'block' },
                  mt: '20px',
                  mb: '5px',
                }}
              >
                <Typography color={'grey'}>Version {packageJson.version}</Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Fade>
    </>
  );
};

export default Signup;
